import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_all_wrkrs_offered_any_of_the_following_programs_by_the_fac'

export const dataPointDefinition = {
  retracedId: 'are_all_wrkrs_offered_any_of_the_following_programs_by_the_fac',
  name: 'Are all workers offered any of the following programs by the facility to promote health?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'NUTRITION',
      text: 'Nutrition',
      externalIds: [
        {
          id: 'ab-1--1-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-1--1-1f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'EXERCISE',
      text: 'Exercise',
      externalIds: [
        {
          id: 'ab-1--1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-1--1-2f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'DRUG_AND_ALCOHOL_ABUSE',
      text: 'Drug and Alcohol Abuse',
      externalIds: [
        {
          id: 'ab-1--1-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-1--1-3f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'SMOKING',
      text: 'Smoking',
      externalIds: [
        {
          id: 'ab-1--1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-1--1-4f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'SEXUAL_HEALTH',
      text: 'Sexual Health',
      externalIds: [
        {
          id: 'ab-1--1-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-1--1-5f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'PRE__AND_POST_NATAL',
      text: 'Pre- and post-natal',
      externalIds: [
        {
          id: 'ab-wor-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-wor-8f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'MENTAL_WELL_BEING',
      text: 'Mental Well-being',
      externalIds: [
        {
          id: 'ab-1--1-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-1--1-6f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'ACCESS_TO_CLEAN_DRINKING_WATER',
      text: 'Access to clean drinking water',
      externalIds: [
        {
          id: 'ab-1--1-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-1--1-7f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ab-1--1-8x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ab-1--1-8f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'ab-1--1-9x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'NUTRITION',
                'EXERCISE',
                'DRUG_AND_ALCOHOL_ABUSE',
                'SMOKING',
                'SEXUAL_HEALTH',
                'PRE__AND_POST_NATAL',
                'MENTAL_WELL_BEING',
                'ACCESS_TO_CLEAN_DRINKING_WATER',
                'OTHER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-wor-3',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 24100,
  sectionId: '2.2.2.2',
  impactArea: 'Worker Wellbeing',
  impactAreaId: 'WORKER_WELLBEING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
